module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Wood#2-69314e9dbecdf255771bbfcb42a92b3f4482fb25c7c66c0a68b99da321534fff.svg";